import T from 'prop-types'
import { warn, error } from '@xhs/logger'

function check(specs, values, location, method) {
  // put check to next loop for performance
  setTimeout(() => {
    try {
      T.checkPropTypes(
        { prop: specs },
        { prop: values },
        location,
        `ozone-bridge/${method}`,
        false,
        true,
      )
    } catch (ex) {
      const message = ex.stack.indexOf(ex.message) > -1
        ? ex.stack
        : `Error: ${ex.message}\n${ex.stack}`

      error(message, null, null, { console: true, owl: true })
    }
  })
}

export function checkArgs(args, argsT, method = '') {
  if (!argsT) {
    warn('argsT is necessary')
    return
  }

  check(argsT, args, 'args', method)
}

export function checkRes(res, resT, method = '') {
  if (!resT) {
    warn('resT is necessary')
    return
  }

  check(resT, res, 'res', method)
}
